import { render, staticRenderFns } from "./RentingPage.vue?vue&type=template&id=2f022898"
import script from "./RentingPage.vue?vue&type=script&lang=js"
export * from "./RentingPage.vue?vue&type=script&lang=js"
import style0 from "./RentingPage.vue?vue&type=style&index=0&id=2f022898&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports